import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingHorizontalL,
  },
  triageStrip: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap' as const,
    paddingBottom: tokens.spacingVerticalS,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  metaRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalS,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  metaLabel: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    width: '80px',
    flexShrink: 0,
  },
  metaValue: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    fontFamily: 'monospace',
  },
  copyBtn: {
    minWidth: 'auto',
    padding: '2px',
  },
  promptSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  promptLabel: {
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },
  promptBox: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'pre-wrap' as const,
  },
  responseBox: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    whiteSpace: 'pre-wrap' as const,
  },
  responseBoxRendered: {
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.5',
    '& p': { marginTop: '4px', marginBottom: '4px' },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      marginTop: '8px',
      marginBottom: '2px',
    },
    '& ul': {
      marginTop: '2px',
      marginBottom: '4px',
      paddingLeft: '20px',
    },
    '& ol': {
      marginTop: '2px',
      marginBottom: '4px',
      paddingLeft: '20px',
    },
    '& li': { marginBottom: '2px' },
    '& strong': { fontWeight: tokens.fontWeightSemibold as unknown as number },
    '& blockquote': {
      marginTop: '4px',
      marginBottom: '4px',
      marginLeft: '0',
      paddingLeft: '12px',
      borderLeft: `3px solid ${tokens.colorNeutralStroke2}`,
      color: tokens.colorNeutralForeground3,
    },
  },
});
